// MST1020_R01 BOM 관련 유틸리티 함수 및 상수

import { allowedAccountsArr } from "src/components/common/common";
import { showWarning } from "src/utils/toast/toastUtil";
import { SYS4100_R01Dto } from "./Dto_SYS4100_R01";


export const headerNames_SYS4100_R01: Record<string, string> = {
        rowIndex: '',
        orgCd: '조직번호',
        orgNm: '부서명',
		upOrgCd: '상위부서',
		displaySeq: '순서',
		orgAdmin: '부서장',
		orgAdminNm: '부서장명',
		createDt: '등록일',
		mergeOrgCd: '통합팀',
		dueDt: '통합일', //통합일 < due_dt
		useYn: '사용여부',
		topOrganiza: '최상위여부',
}

// 원본 데이터 복구 함수
export function restoreOriginalValues(
  valueIndex: number,
  originalData: SYS4100_R01Dto,
  updateSYS4100_R01List: (index: number, data: SYS4100_R01Dto) => void,
  gridRef: any
) {
  setTimeout(() => {
    updateSYS4100_R01List(valueIndex, {
      ...originalData,
      isModified: originalData.inserted === true ? false : true
    });
    if (gridRef.current?.api) {
      const allRowNodes: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.data && node.data.valueIndex === valueIndex) {
          allRowNodes.push(node);
        }
      });
      if (allRowNodes.length > 0) {
        const targetNode = allRowNodes[0];
      }
    }
  }, 100);
}

// 행 편집 가능 여부
export function isEditableRow(
  params: any,
  originalSYS4100_R01List: SYS4100_R01Dto[],
  deletedSYS4100_R01List: (string | number)[]
): boolean {
  if (params.data?.inserted) return true;
  const originalData = originalSYS4100_R01List.find(item => item.valueIndex === params.data?.valueIndex);
  return true;
}

// 날짜 컬럼 클릭 시 편집 가능 여부
export function validateDateColumns(
  field: string,
  data: any,
  originalSYS4100_R01List: SYS4100_R01Dto[],
  dateColumns: string[]
): boolean {
  const originalData = originalSYS4100_R01List.find(item => item.valueIndex === data.valueIndex);
  return true;
}

// 품목 계정 검증
export function validateItemAccount(itemAccount: string) {
  return allowedAccountsArr.includes(itemAccount);
}